import React from "react";
import { StepConnector } from "@mui/material";
import { styled } from "@mui/material/styles";
import RpSteps from "./RpSteps";

const CustomStepConnector = styled(StepConnector)(() => ({
  "&.MuiStepConnector-alternativeLabel": {
    top: 22,
  },
  "&.MuiStepConnector-active": {
    "& .MuiStepConnector-line": {
      backgroundColor: "var(--primary-base)",
    },
  },
  "&.MuiStepConnector-completed": {
    "& .MuiStepConnector-line": {
      backgroundColor: "var(--primary-base)",
    },
  },
  "& .MuiStepConnector-line": {
    height: 3,
    border: 0,
    backgroundColor: "var(--primary-base)",
    borderRadius: "var(--radius-round)",
  },
}));

type CheckoutStepperProps = {
  activeStep?: number;
};

function CheckoutStepper(step: CheckoutStepperProps) {
  return (
    <RpSteps
      activeStep={step?.activeStep}
      steps={["Choose your plan", "Review your order", "Payment"]}
      connector={<CustomStepConnector />}
    />
  );
}

export default CheckoutStepper;
